import { createSelector } from 'reselect'

const getLessonsPicker = state => state.lessonsPicker
const getLibraryFolder = state => state.myLibrary.folderUID

const privateLibraryLessonsPickerModalSaveSelector = createSelector(
	[ getLessonsPicker, getLibraryFolder ],
	(lessons_picker, folderUID) => ({
		lessons: lessons_picker.selected_lessons.join(','),
		folderUID,
	})
)

export default privateLibraryLessonsPickerModalSaveSelector
